module.exports = __webpack_public_path__ + "media/images/stock_groups/e869-136b4ce8c5fb9f21345a9c7e17fb9a3c.svg";